import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { v4 as uuidv4 } from 'uuid';
import { environment } from "../../environments/environment";
import { SpinnerService } from "./services/spinner.service";

@Injectable()
export class SpinInterceptor implements HttpInterceptor {

  // Calls that must not block the page with the overlay (search-as-you-type autocompletes)
  private ignoreUrls: string[] = [
    "/api/role/opt/user/startwith",
  ];

  constructor(private spin: SpinnerService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let uuid: string | null = null;
    const url = request.url.replace(environment.base_url, "").toLowerCase();
    const ignore = this.ignoreUrls.some(u => url.includes(u));
    if (!ignore) {
      uuid = uuidv4();
      this.spin.add(uuid);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!ignore && uuid) {
          this.spin.stop(uuid);
        }
      })
    );
  }
}
